<template>
  <el-dialog
    :visible.sync="isShowDialog" class="dialog-square"
    :title="$t('menu.pickupTime')" center width="400px"
    :close-on-click-modal="false" @close="whenDialogClose">
    <div class="dialog-con df-l-c-fs w100p">
      <div class="dialog-ctr w100p">
        <div class="mydialog df-c-ct">

          <div class="box df-c-sb">
            <div class="window df-l-c-sb" ref="window1" @scroll="windowScroll(1)">
              <div class="cell"></div>
              <div class="cell" :class="{'cell-light':lightCount1===i}" v-for="(x,i) in 24" :key="i">{{i|toTwo}}</div>
              <div class="cell"></div>
            </div>
            <div class="window df-l-c-sb" ref="window2" @scroll="windowScroll(2)">
              <div class="cell"></div>
              <div class="cell" :class="{'cell-light':lightCount2===i}" v-for="(x,i) in 60" :key="i">{{i|toTwo}}</div>
              <div class="cell"></div>
            </div>
          </div>
          
        </div>
      </div>
      <div class="dialog-btm w100p df-c-sa">
        <div class="themebtn" @click="submitDialog">{{$t('common.comfirm')}}</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'DialogTimePicker',
  data() {
    return {
      isShowDialog: false,
      fData: {
        time: ''
      },

      scrolltimer1: null,
      scrolltimer2: null,
      lightCount1: 0,
      lightCount2: 0,
    }
  },
  filters: {
    toTwo: (val) => {
      if (val < 10) {
        return '0' + val
      } else {
        return val
      }
    },
  },
  methods: {
    open(value) {
      console.log(`%c时间:`, 'color: #f0f;', value)
      this.scan_canLeave_x_save(false)
      this.isShowDialog = true
      this.$nextTick(() => {
        const arr = value.split(':')
        this.$refs.window1.scrollTop = Number(arr[0]) * 60
        this.$refs.window2.scrollTop = Number(arr[1]) * 60
        this.lightCount1 = Number(arr[0])
        this.lightCount2 = Number(arr[1])
      })
    },
    close() {
      this.isShowDialog = false
    },
    whenDialogClose() {
      this.scan_canLeave_x_save(true)
      this.isShowDialog = false
      this.$emit('close')
      clearTimeout(this.scrolltimer1)
      clearTimeout(this.scrolltimer2)
      // this.$refs.window1.scrollTop = 0
      // this.$refs.window2.scrollTop = 0
      // this.lightCount1 = 0
      // this.lightCount2 = 0
    },

    windowScroll(index) {
      clearTimeout(this['scrolltimer' + index])
      // console.log(`%c滑动中`, 'color: #00f;', )
        
      const SCROLLTOP = this.$refs['window' + index].scrollTop

      let NEWTOP = 0
      let n = 0
      if (SCROLLTOP % 60 < 30) {
        n = Math.floor(SCROLLTOP / 60)
      } else {
        n = Math.ceil(SCROLLTOP / 60)
      }
      NEWTOP = n * 60
      this['lightCount' + index] = n
      // console.log(`%cSCROLLTOP, NEWTOP:`, 'color: #00f;', SCROLLTOP, NEWTOP)

      this['scrolltimer' + index] = setTimeout(() => {
        // console.log(`%c滑动停止了`, 'color: #00f;', )

        this.$refs['window' + index].scrollTop = NEWTOP

        clearTimeout(this['scrolltimer' + index])
      }, 300)
    },

    submitDialog() {
      const n1 = this.lightCount1 < 10 ? '0' + this.lightCount1 : this.lightCount1
      const n2 = this.lightCount2 < 10 ? '0' + this.lightCount2 : this.lightCount2
      const time = n1 + ':' + n2
      this.$emit('submitDialog', time)
      this.close()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util_dialog.scss';
.mydialog{
  padding: 80px 40px;
  .box{
    height: 100%;position: relative;
    .window{
      --h: 60px;
      width: 80px;height: calc(var(--h) * 3);overflow: hidden scroll;
      // background: #0ff;
      .cell{
        height: var(--h);line-height: var(--h);
        font-size: 24px;font-weight: bold;color: #ccc;
        flex-shrink: 0;
        // &:nth-child(2n+1){background: #f0f;}
        // &:nth-child(2n){background: #0f0;}
        &.cell-light{
          color: #000;font-size: 36px;
          // background: #0f0;
        }
      }
    }

    // &::before, &::after {
    //   content: '';display: inline-block;width: 0;height: 0;
    //   border: 12px solid transparent;position: absolute;top: 0;bottom: 0;margin: auto;
    // }
    // &::before{border-left: 12px solid #000;left: -40px;}
    // &::after{border-right: 12px solid #000;right: -40px;}

    &::before, &::after {
      content: '';display: inline-block;width: 0;height: 0;
      border: 12px solid transparent;position: absolute;left: 0;right: 0;margin: auto;
    }
    &::before{border-bottom: 12px solid #000;top: -40px;}
    &::after{border-top: 12px solid #000;bottom: -40px;}
  }
}
</style>